export type SupportedLanguage = {
  code: string;
  label: string;
  flag: string;
};

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

export const DEFAULT_LANGUAGE = "en";

export function isSupportedLanguage(code: string): boolean {
  return SUPPORTED_LANGUAGES.some((l) => l.code === code);
}

export function resolveLanguage(code: string | undefined | null): string {
  if (code && isSupportedLanguage(code)) return code;
  return DEFAULT_LANGUAGE;
}
